var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingChoiceLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5631 25.3051C7.72405 24.7323 5.17072 23.1947 3.33645 20.9534C1.50219 18.712 0.5 15.905 0.5 13.0087C0.5 10.1125 1.50219 7.30555 3.33645 5.06421C5.17072 2.82288 7.72405 1.28532 10.5631 0.712494V25.3051Z",
    fill: "#F57F29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 25.3051V13.3421C21.7502 13.3398 19.112 14.4293 17.1652 16.3713C15.2184 18.3133 14.1223 20.9488 14.1178 23.6986V25.3051H24.5Z",
    fill: "#FFCE34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1093 0.712494V12.6755C16.8599 12.6778 19.4989 11.5885 21.4471 9.64676C23.3952 7.70502 24.4932 5.06949 24.5 2.31892V0.712494H14.1093Z",
    fill: "#FFCE34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingChoiceLogoSmall);
export default __webpack_public_path__ + "static/media/landing-choice-logo-small.9b5332863b28589d99f65cf33edc5260.svg";
export { ForwardRef as ReactComponent };